import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { getDraftShareIdFromQueryParam } from '@confluence/route-manager-utils/entry-points/getDraftShareIdFromQueryParam';

import useEmojiEverSetPropertyQuery from './emoji-title/__generated__/useEmojiEverSetPropertyQuery.graphql';

export const preloadEmojiEverSetProperty = (contentId: string) => {
	return query({
		query: useEmojiEverSetPropertyQuery,
		variables: {
			contentId,
			status: ['current', 'draft'],
			draftShareId: getDraftShareIdFromQueryParam(),
		},
	});
};
